import { BrandList } from 'components/product/brand-list/BrandList'
import { useLocation, useSearchParams } from 'react-router-dom'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'
import { INITIAL_DATA_FILTER } from 'configs/product/configTableBrandList'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_BRAND } from 'services/apiBrand'
import moment from 'moment/moment'
import { Alert } from 'avo-ui'

const INIT_STATUS = [
    {
        label: 'Active',
        value: 'active',
    },
    {
        label: 'Inactive',
        value: 'inactive',
    },
]

export const BrandListContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [selectedIds, setSelectedIds] = useState([])
    const [selectedStatus, setSelectedStatus] = useState(INIT_STATUS[0])
    const { fetching: getBrandList, data: brandList, isLoading } = useFetch(API_BRAND.LIST)
    const { fetching: updateStatus, isLoading: isUpdating } = useFetch(API_BRAND.UPDATE_STATUS)
    const { fetching: exportBrand, isLoading: isExporting } = useFetch(API_BRAND.EXPORT)
    const [modal, setModal] = useState({
        export: false,
        confirm: false,
    })

    useEffect(() => {
        fetchBrandList()
    }, [location?.search])

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchBrandList = (item = { ...query }) => {
        getBrandList(item)
    }

    const onSelectSort = (value) => {
        const splitSort = value?.split('-')
        onChangeQuery({ order_by: splitSort[0], order_type: splitSort[1] })
    }

    const onChangeStatus = (item) => {
        setSelectedStatus(item?.value)
    }

    const onExport = () => {
        const { page, limit, ...queryRest } = query
        const payload = { ...queryRest, ids: selectedIds }
        exportBrand(payload, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `Brand-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setShowAlert('Brand Exported !', { export: false })
        })
    }

    const onConfirm = () => {
        const payload = {
            status: selectedStatus?.value,
            ids: selectedIds,
        }
        updateStatus(payload).then(() => {
            setShowAlert('Brand Status Updated !', { confirm: false })
            fetchBrandList()
        })
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const props = {
        dataList: brandList?.data,
        modal,
        setShowModal,
        onSelectSort,
        query,
        onChangeQuery,
        selectedIds,
        statusOptions: INIT_STATUS,
        selectedStatus,
        onChangeStatus,
        onExport,
        onConfirm,
        onSelectItemHandler,
        isLoading,
        isUpdating,
        isExporting,
    }

    return <BrandList {...props} />
}
